import "./ModalEmpleado.css";
import React, { useContext, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { DarkModeContext } from "../../context/DarkModeContext";
import { useForm, Controller } from "react-hook-form";
import Swal from "sweetalert2";
import { getToken } from "../../utils/auth";


const ModalEmpleado = ({ show, onHide, onActualizarDatos, empleado }) => {
    const { darkMode } = useContext(DarkModeContext);
    const { control, handleSubmit, reset, setValue, formState: { errors } } = useForm();

    useEffect(() => {
        if (empleado) {
            Object.entries(empleado).forEach(([key, value]) => setValue(key, value || ""));
        } else {
            reset();
        }
    }, [empleado, setValue, reset]);

    const onSubmit = async (data) => {
        try {
            const token = getToken();
            const url = empleado
                ? process.env.REACT_APP_API_EMPLEADO_INTERNO_EDITAR
                : process.env.REACT_APP_API_EMPLEADO_INTERNO_CREAR;

            const body = empleado
                ? { ...data, Id: empleado.id, Token: token }
                : { ...data, Token: token };

            const response = await fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
            });

            if (!response.ok) throw new Error("Error en la operación");
            Swal.fire({
                title: empleado ? "¡Empleado editado!" : "¡Empleado creado!",
                icon: "success",
            });
            onActualizarDatos();
            onHide();
        } catch (error) {
            Swal.fire("Error", "No se pudo guardar el empleado.", "error");
        }
    };

    // Cada input en su propio bloque con gradiente tipo bg-tabla-usuarios-liquidaciones
    const campo = (label, name, type = "text") => (
        <div className={`campo-modal-empleado${darkMode ? " campo-modal-empleado-dark" : ""}`}>
            <Form.Label className="label-modal-empleado">{label}</Form.Label>
            <Controller
                name={name}
                control={control}
                defaultValue=""
                render={({ field }) => (
                    <Form.Control
                        {...field}
                        type={type}
                        className="input-modal-empleado"
                        autoComplete="off"
                    />
                )}
            />
            {errors[name] && (
                <p className="error-modal-empleado">{errors[name].message}</p>
            )}
        </div>
    );

    return (
        <Modal show={show} onHide={onHide} size="xl" centered>
            <Modal.Body>
                <h5 className="mb-4" style={{ fontWeight: 700 }}>
                    {empleado ? "Editar Empleado" : "Nuevo Empleado"}
                </h5>
                <Form onSubmit={handleSubmit(onSubmit)} className="form-modal-empleado">
                    <div className="modal-form-scroll">
                        <Row className="gx-3">
                            <Col md={4}>{campo("Legajo", "legajo")}</Col>
                            <Col md={4}>{campo("Razón Social", "razonSocial")}</Col>
                            <Col md={4}>{campo("Estado", "estado")}</Col>
                        </Row>
                        <Row className="gx-3">
                            <Col md={4}>{campo("Apellido", "apellido")}</Col>
                            <Col md={4}>{campo("Nombre", "nombre")}</Col>
                            <Col md={4}>{campo("DNI", "dni")}</Col>
                        </Row>
                        <Row className="gx-3">
                            <Col md={4}>{campo("CUIL", "cuil")}</Col>
                            <Col md={4}>{campo("Domicilio", "domicilio")}</Col>
                            <Col md={4}>{campo("Ciudad", "ciudad")}</Col>
                        </Row>
                        <Row className="gx-3">
                            <Col md={4}>{campo("Provincia", "provincia")}</Col>
                            <Col md={4}>{campo("Código Postal", "codigoPostal")}</Col>
                            <Col md={4}>{campo("Fecha Nac.", "fechaNacimiento", "date")}</Col>
                        </Row>
                        <Row className="gx-3">
                            <Col md={4}>{campo("Celular", "celular")}</Col>
                            <Col md={4}>{campo("Email", "email")}</Col>
                            <Col md={4}>{campo("Estado Civil", "estadoCivil")}</Col>
                        </Row>
                        <Row className="gx-3">
                            <Col md={4}>{campo("Emergencia", "emergencia")}</Col>
                            <Col md={4}>{campo("Hijos Dep.", "hijosDependientes")}</Col>
                            <Col md={4}>{campo("Parentesco 1", "parentesco1")}</Col>
                        </Row>
                        <Row className="gx-3">
                            <Col md={4}>{campo("Parentesco 2", "parentesco2")}</Col>
                            <Col md={4}>{campo("Parentesco 3", "parentesco3")}</Col>
                            <Col md={4}>{campo("Parentesco 4", "parentesco4")}</Col>
                        </Row>
                        <Row className="gx-3">
                            <Col md={4}>{campo("Parentesco 5", "parentesco5")}</Col>
                            <Col md={4}>{campo("Secundarios", "secundarios")}</Col>
                            <Col md={4}>{campo("Terciarios/Univ", "terciariosUniv")}</Col>
                        </Row>
                        <Row className="gx-3">
                            <Col md={4}>{campo("Posgrado", "posgrado")}</Col>
                            <Col md={4}>{campo("Fecha Ingreso", "fechaIngreso", "date")}</Col>
                            <Col md={4}>{campo("Área", "area")}</Col>
                        </Row>
                        <Row className="gx-3">
                            <Col md={4}>{campo("Puesto", "puesto")}</Col>
                            <Col md={4}>{campo("Horario Laboral", "horarioLaboral")}</Col>
                            <Col md={4}>{campo("CBU", "cbu")}</Col>
                        </Row>
                        <Row className="gx-3">
                            <Col md={4}>{campo("Alias", "alias")}</Col>
                            <Col md={4}>{campo("Banco", "banco")}</Col>
                            <Col md={4}>{campo("PDF CBU", "pdfCbu")}</Col>
                        </Row>
                        <Row className="gx-3">
                            <Col md={4}>{campo("Validado", "validado")}</Col>
                            <Col md={4}>{campo("Correos Corp.", "correosCorporativos")}</Col>
                            <Col md={4}>{campo("Modalidad", "modalidad")}</Col>
                        </Row>
                        <Row className="gx-3">
                            <Col md={4}>{campo("Tipo Servicio", "tipoServicio")}</Col>
                            <Col md={4}>{campo("Fecha Alta", "fechaAlta", "date")}</Col>
                            <Col md={4}>{campo("Hs Trabajo", "horasTrabajo")}</Col>
                        </Row>
                        <Row className="gx-3">
                            <Col md={4}>{campo("Fecha Baja", "fechaBaja", "date")}</Col>
                        </Row>
                    </div>
                    <div className="d-flex justify-content-between mt-4">
                        <Button variant="secondary" onClick={onHide}>
                            Cancelar
                        </Button>
                        <Button type="submit" className="btn-guardar-usuario-editar border-0 lato-bold">
                            Guardar
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default ModalEmpleado;
